/**
 * The Type of message returned by a websocket (or webhook).
 *
 * @see https://docs.pos.payyo.ch/docs/notifications/overview/
 */
const PayyoSocketResponseType = Object.freeze({
    DEVICE_STATUS: 'device_status',
    // Device status
    ERROR: 'error',
    // Error occurred
    // event.error is error message
    PAYMENT_AUTHORIZED: 'payment_authorized',
    // Payment has been successfully authorized and can be captured
    // event.payment is payment object
    PAYMENT_CANCELED: 'payment_canceled',
    // Payment has been canceled
    // event.payment is payment object
    PAYMENT_CREATED: 'payment_created',
    // Payment has been created
    // event.payment is payment object
    PAYMENT_FAILED: 'payment_failed',
    // Payment has failed
    // event.payment is payment object
    PAYMENT_REFUNDED: 'payment_refunded',
    // Payment has been refunded
    // event.refund is refund object
    PAYMENT_SUCCEEDED: 'payment_succeeded',
    // Payment has been successfully completed
    // event.payment is payment object
});

module.exports = PayyoSocketResponseType;
